import { render } from "./SelectedElements.vue?vue&type=template&id=7492a868"
import script from "./SelectedElements.vue?vue&type=script&lang=js"
export * from "./SelectedElements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__